import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function PenjalisteIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PenjalisteIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="currentcolor" d="M56.7,49.2c14.4-7.1,19.9-31.5,19.9-33.6h-2C74,20.8,67.8,41.1,56.7,47V49.2z M47.1,33.3
	c2.9,0,5.2-2.3,5.2-5.2s-2.3-5.2-5.2-5.2s-5.2,2.4-5.2,5.2S44.2,33.3,47.1,33.3z M54.5,63.1l-2.2,1v21.5h2.2V63.1z M54.5,52.6v2.2
	H41.4L31.1,78.4c-0.8,1.8,0.1,4.1,1.9,5.1s4,0.4,4.7-1.3l8.4-19.3c0.7,0.2,1.5,0.3,2.4,0.3c0.7,0,1.5-0.2,2.1-0.4l9.4-4.4l2.1,8.3
	c0.4,1.8,2.3,3,4.2,2.5c1.8-0.5,3-2.3,2.5-4.2l-3.3-13c-0.5-1.9-2.7-3.3-4.5-2.5L54.5,52.6V40.4l11.7-18.8c0.9-1.4,0.5-3.2-0.9-4.1
	s-3.2-0.4-4,0.9l-10,16h-6c-0.4,0-0.8,0.1-1.1,0.2l-10.4,4.1l-5.4-8.1c-0.9-1.4-2.7-1.8-4.1-0.9s-1.8,2.7-0.9,4.1l6.7,10.1
	c0.7,1.2,2.3,1.7,3.6,1.1l7.6-3v10.5L54.5,52.6L54.5,52.6z"/>
    </svg>
  </SvgIcon>
}

export default PenjalisteIcon;
